import { render, staticRenderFns } from "./report-loan-status.vue?vue&type=template&id=332594b8&scoped=true&"
import script from "./report-loan-status.vue?vue&type=script&lang=ts&"
export * from "./report-loan-status.vue?vue&type=script&lang=ts&"
import style0 from "./report-loan-status.vue?vue&type=style&index=0&id=332594b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332594b8",
  null
  
)

export default component.exports